import { render, staticRenderFns } from "./OTRCOD0200.vue?vue&type=template&id=349ff564&scoped=true&"
import script from "./OTRCOD0200.js?vue&type=script&lang=js&"
export * from "./OTRCOD0200.js?vue&type=script&lang=js&"
import style0 from "./OTRCOD0200.vue?vue&type=style&index=0&id=349ff564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349ff564",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCardText,VChip,VContainer,VDataTable,VIcon,VRow,VSelect})
